import { Box } from "@chakra-ui/react";
import GigPostLayout from "../components/gigpostpage/GigpostLayout";
import CommonContainer from "../components/shared/CommonContainer";

export default function GigPostPage() {
  return (
    <>
      <CommonContainer>
        <Box py={10}>
          <GigPostLayout />
        </Box>
      </CommonContainer>
    </>
  );
}
